function Footer() {
  return (
    <footer className="footer">
      <p>© AGP India Organic. All rights reserved.</p>
    </footer>
  );
}

export default Footer;